(function () {
  'use strict';

  var emblaPromise = null;

  function loadScript(src) {
    if (!src) return Promise.reject(new Error('missing script src'));
    if (window.EmblaCarousel) return Promise.resolve(window.EmblaCarousel);
    if (emblaPromise) return emblaPromise;
    emblaPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.EmblaCarousel); }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = function () { resolve(window.EmblaCarousel); };
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return emblaPromise;
  }

  function moneyFormatter(root) {
    var currency = root.getAttribute('data-pdp-currency') || 'EUR';
    return function (value) {
      try {
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency, useGrouping: 'always' }).format(value || 0);
      } catch (error) {
        return '€' + (value || 0).toFixed(2).replace('.', ',');
      }
    };
  }

  function decimalFormatter(value) {
    try {
      return new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0);
    } catch (error) {
      return (value || 0).toFixed(2).replace('.', ',');
    }
  }

  function readVariants(root) {
    var node = root.querySelector('[data-pdp-variants-json]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function readStockConfirmations(root) {
    var node = root.querySelector('[data-pdp-stock-confirmations-json]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function pauseInactiveMedia(root, activeIndex) {
    root.querySelectorAll('[data-pdp-slide]').forEach(function (slide) {
      if (parseInt(slide.getAttribute('data-pdp-slide'), 10) === activeIndex) return;
      slide.querySelectorAll('video').forEach(function (video) {
        if (!video.paused) video.pause();
      });
    });
  }

  function setSkeletonDone(slide) {
    if (!slide) return;
    var image = slide.querySelector('img');
    function done() { slide.setAttribute('aria-busy', 'false'); }
    if (!image || (image.complete && image.naturalWidth !== 0)) done();
    else {
      image.addEventListener('load', done, { once: true });
      image.addEventListener('error', done, { once: true });
    }
  }

  function initFallbackGallery(root, thumbs, slides) {
    function activate(index) {
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-pdp-thumb') === String(index));
      });
      slides.forEach(function (slide) {
        var active = slide.getAttribute('data-pdp-slide') === String(index);
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (active) setSkeletonDone(slide);
      });
      pauseInactiveMedia(root, index);
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(parseInt(thumb.getAttribute('data-pdp-thumb'), 10) || 0);
      });
    });
    return { activate: activate };
  }

  function initGallery(root) {
    var viewport = root.querySelector('[data-pdp-gallery-main]');
    var track = root.querySelector('[data-pdp-gallery-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
    if (!viewport || !track || !slides.length) return;

    if (slides.length === 1) {
      setSkeletonDone(slides[0]);
      viewport.classList.add('is-single');
      root.gefPdpGallery = {
        activate: function () { setSkeletonDone(slides[0]); }
      };
      initLightbox(root);
      return;
    }

    var fallback = initFallbackGallery(root, thumbs, slides);
    var galleryController = {
      index: 0,
      activate: function (index) {
        var next = Math.max(0, Math.min(parseInt(index, 10) || 0, slides.length - 1));
        galleryController.index = next;
        fallback.activate(next);
      }
    };
    root.gefPdpGallery = galleryController;
    var emblaSrc = root.getAttribute('data-pdp-embla-src') ||
      (window.GEF_MOTION_VENDOR_URLS && window.GEF_MOTION_VENDOR_URLS.embla);

    loadScript(emblaSrc).then(function (EmblaCarousel) {
      if (typeof EmblaCarousel !== 'function') return;
      slides.forEach(function (slide) { slide.hidden = false; });
      viewport.classList.add('is-embla');
      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false,
        skipSnaps: false
      });

      function sync() {
        var index = embla.selectedScrollSnap();
        thumbs.forEach(function (thumb) {
          var active = thumb.getAttribute('data-pdp-thumb') === String(index);
          thumb.classList.toggle('is-active', active);
          if (active) {
            var strip = thumb.closest('.gef-cd-pdp__gallery-thumbs');
            if (strip && strip.scrollWidth > strip.clientWidth && typeof strip.scrollTo === 'function') {
              var stripRect = strip.getBoundingClientRect();
              var thumbRect = thumb.getBoundingClientRect();
              var centeredLeft = strip.scrollLeft + thumbRect.left - stripRect.left -
                ((stripRect.width - thumbRect.width) / 2);
              strip.scrollTo({ left: Math.max(0, centeredLeft), behavior: 'smooth' });
            }
          }
        });
        slides.forEach(function (slide) {
          var active = slide.getAttribute('data-pdp-slide') === String(index);
          slide.classList.toggle('is-active', active);
          if (active) setSkeletonDone(slide);
        });
        pauseInactiveMedia(root, index);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          embla.scrollTo(parseInt(thumb.getAttribute('data-pdp-thumb'), 10) || 0);
        });
      });
      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          embla.scrollNext();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          embla.scrollPrev();
        }
      });
      embla.on('select', sync);
      embla.on('reInit', sync);
      galleryController.activate = function (index) {
        var next = Math.max(0, Math.min(parseInt(index, 10) || 0, slides.length - 1));
        galleryController.index = next;
        embla.scrollTo(next, true);
        sync();
      };
      galleryController.activate(galleryController.index);
    }).catch(function () {
      fallback.activate(galleryController.index);
    });

    initLightbox(root);
  }

  function initLightbox(root) {
    var gallery = root.querySelector('[data-pdp-gallery-main]');
    if (!gallery) return;
    function openLightbox(image) {
      if (!image || document.querySelector('.gef-cd-pdp-lightbox')) return;
      var returnFocus = document.activeElement;
      var overlay = document.createElement('div');
      overlay.className = 'gef-cd-pdp-lightbox';
      overlay.innerHTML =
        '<button type="button" class="gef-cd-pdp-lightbox__close" aria-label="Chiudi zoom">×</button>' +
        '<img>';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Immagine prodotto ingrandita');
      var zoomImage = overlay.querySelector('img');
      zoomImage.src = image.currentSrc || image.src;
      zoomImage.alt = image.getAttribute('alt') || '';
      document.body.appendChild(overlay);
      document.body.classList.add('gef-cd-lightbox-lock');
      var closeButton = overlay.querySelector('button');
      var close = function () {
        overlay.remove();
        document.body.classList.remove('gef-cd-lightbox-lock');
        document.removeEventListener('keydown', onKey);
        if (returnFocus && typeof returnFocus.focus === 'function') {
          returnFocus.focus({ preventScroll: true });
        }
      };
      var onKey = function (keyEvent) {
        if (keyEvent.key === 'Escape') close();
        if (keyEvent.key === 'Tab') {
          keyEvent.preventDefault();
          closeButton.focus();
        }
      };
      overlay.addEventListener('click', function (clickEvent) {
        if (clickEvent.target === overlay || clickEvent.target.closest('.gef-cd-pdp-lightbox__close')) close();
      });
      document.addEventListener('keydown', onKey);
      closeButton.focus();
    }
    gallery.addEventListener('click', function (event) {
      var image = event.target.closest('.gef-cd-pdp__gallery-img');
      if (!image) return;
      event.preventDefault();
      openLightbox(image);
    });
    gallery.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var image = gallery.querySelector('.gef-cd-pdp__gallery-slide.is-active .gef-cd-pdp__gallery-img') ||
        gallery.querySelector('.gef-cd-pdp__gallery-img');
      if (!image) return;
      event.preventDefault();
      openLightbox(image);
    });
  }

  function initCopy(root) {
    root.querySelectorAll('[data-pdp-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-pdp-copy');
        if (!navigator.clipboard || !value) return;
        navigator.clipboard.writeText(value).then(function () {
          var label = button.querySelector('[data-pdp-copy-label]');
          if (!label) return;
          var previous = label.textContent;
          label.textContent = 'copiato';
          window.setTimeout(function () { label.textContent = previous; }, 1500);
        });
      });
    });
  }

  function initWishlist(root) {
    var key = 'gef_saved_products';
    function read() {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); }
      catch (error) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(key, JSON.stringify(list.slice(0, 100))); }
      catch (error) {}
    }
    function sync() {
      var list = read();
      root.querySelectorAll('[data-pdp-wishlist]').forEach(function (button) {
        var handle = button.getAttribute('data-product-handle') || root.getAttribute('data-product-handle');
        var active = list.indexOf(handle) !== -1;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.setAttribute('aria-label', active ? 'Rimuovi dai preferiti' : 'Salva nei preferiti');
      });
    }
    root.querySelectorAll('[data-pdp-wishlist]').forEach(function (button) {
      button.addEventListener('click', function () {
        var handle = button.getAttribute('data-product-handle') || root.getAttribute('data-product-handle');
        var list = read();
        var index = list.indexOf(handle);
        if (index !== -1) list.splice(index, 1);
        else list.unshift(handle);
        write(list);
        sync();
      });
    });
    sync();
  }

  function initPurchase(root) {
    var formatMoney = moneyFormatter(root);
    var variants = readVariants(root);
    var stockConfirmations = readStockConfirmations(root);
    var form = root.querySelector('#gef-cd-pdp-form');
    var stockVariantSelect = root.querySelector('[data-stock-confirmation-variant]');
    var stockRequestQuantity = root.querySelector('[data-stock-confirmation-quantity]');
    var stockRequestCta = root.querySelector('[data-stock-confirmation-cta]');
    var qtyInput = root.querySelector('.gef-cd-pdp__qty-input');
    var unitBox = root.querySelector('[data-pdp-unit-box]');
    var unitOut = unitBox ? unitBox.querySelector('[data-price-per-unit]') : null;
    var totalOut = unitBox ? unitBox.querySelector('[data-total-estimate]') : null;
    var bulkRoot = root.querySelector('[data-gef-cd-bulk]');
    var currentBulkDetail = null;
    var priceMain = root.querySelector('[data-bulk-price]');
    var priceSub = root.querySelector('[data-bulk-sub]');
    var priceCompare = root.querySelector('[data-bulk-compare]');
    var pricePct = root.querySelector('[data-bulk-pct]');
    var variantInput = form ? form.querySelector('[data-pdp-variant-id]') : null;
    var addButton = form ? form.querySelector('[data-pdp-add-button]') : null;
    var addLabel = addButton ? addButton.querySelector('[data-pdp-add-label]') : null;
    var variantStatus = form ? form.querySelector('[data-pdp-variant-status]') : null;
    var stockIndicator = root.querySelector('[data-pdp-stock-indicator]');
    var stockLabel = stockIndicator ? stockIndicator.querySelector('[data-pdp-stock-label]') : null;
    var deliveryBox = root.querySelector('[data-pdp-delivery]');
    var deliveryTitle = deliveryBox ? deliveryBox.querySelector('[data-pdp-delivery-title]') : null;
    var deliveryNote = deliveryBox ? deliveryBox.querySelector('[data-pdp-delivery-note]') : null;
    var skuText = root.querySelector('.gef-cd-pdp__code-text');
    var copyButton = root.querySelector('[data-pdp-copy]');
    var vatMultiplier = parseFloat(root.getAttribute('data-pdp-vat-multiplier')) || 1.22;
    var priceMode = root.getAttribute('data-price-mode') === 'incl' ? 'incl' : 'excl';
    var isProtectedStockProduct = root.getAttribute('data-protected-stock-vendor') === 'true';
    var protectedStockLabel = root.getAttribute('data-protected-stock-label') || 'Disponibile';
    var ownedStockLabel = root.getAttribute('data-owned-stock-label') || 'Pronta consegna';
    var availableStockLabel = root.getAttribute('data-available-stock-label') || 'Disponibile';

    function hasVerifiedOwnedStock(variant) {
      if (!variant || isProtectedStockProduct) return false;
      var quantity = parseInt(variant.inventory_quantity, 10) || 0;
      return variant.inventory_management === 'shopify' && quantity > 0;
    }

    function requiresStockConfirmation(variant) {
      if (!variant) return false;
      return stockConfirmations[String(variant.id)] === true;
    }

    function navigateToVariant(variantId) {
      if (!variantId) return;
      var next = new URL(window.location.href);
      next.searchParams.set('variant', String(variantId));
      if (stockRequestQuantity) {
        var requestedQuantity = parseInt(stockRequestQuantity.value, 10);
        if (Number.isFinite(requestedQuantity) && requestedQuantity >= 1 && requestedQuantity <= 9999) {
          next.searchParams.set('quantity', String(requestedQuantity));
        }
      }
      window.location.assign(next.toString());
    }

    if (stockVariantSelect) {
      stockVariantSelect.addEventListener('change', function () {
        navigateToVariant(stockVariantSelect.value);
      });
    }

    function syncStockRequestQuantity() {
      if (!stockRequestQuantity || !stockRequestCta) return;
      var requestedQuantity = parseInt(stockRequestQuantity.value, 10);
      var valid = Number.isFinite(requestedQuantity) && requestedQuantity >= 1 && requestedQuantity <= 9999;
      stockRequestCta.classList.toggle('is-disabled', !valid);
      stockRequestCta.setAttribute('aria-disabled', valid ? 'false' : 'true');
      if (!valid) return;
      stockRequestQuantity.value = String(requestedQuantity);
      var next = new URL(stockRequestCta.href, window.location.origin);
      next.searchParams.set('quantity', String(requestedQuantity));
      stockRequestCta.href = next.toString();
    }

    if (stockRequestQuantity && stockRequestCta) {
      var quantityFromUrl = parseInt(new URL(window.location.href).searchParams.get('quantity'), 10);
      if (Number.isFinite(quantityFromUrl) && quantityFromUrl >= 1 && quantityFromUrl <= 9999) {
        stockRequestQuantity.value = String(quantityFromUrl);
      }
      stockRequestQuantity.addEventListener('input', syncStockRequestQuantity);
      stockRequestQuantity.addEventListener('change', syncStockRequestQuantity);
      stockRequestCta.addEventListener('click', function (event) {
        syncStockRequestQuantity();
        if (stockRequestCta.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          stockRequestQuantity.focus();
          if (typeof stockRequestQuantity.reportValidity === 'function') stockRequestQuantity.reportValidity();
        }
      });
      syncStockRequestQuantity();
    }

    function clampQty() {
      if (!qtyInput) return 1;
      var value = parseInt(qtyInput.value, 10) || parseInt(qtyInput.min, 10) || 1;
      var min = parseInt(qtyInput.min, 10) || 1;
      var max = qtyInput.max ? parseInt(qtyInput.max, 10) : null;
      var step = parseInt(qtyInput.step, 10) || 1;
      value = Math.max(value, min);
      if (max) value = Math.min(value, max);
      if (step > 1) value = min + Math.round((value - min) / step) * step;
      qtyInput.value = value;
      return value;
    }

    function findVariantById(id) {
      if (!id) return variants[0] || null;
      return variants.find(function (variant) {
        return String(variant.id) === String(id);
      }) || variants[0] || null;
    }

    function variantText(variant) {
      if (!variant) return '';
      return [
        variant.title,
        Array.isArray(variant.options) ? variant.options.join(' ') : '',
        variant.sku
      ].join(' ').toLowerCase();
    }

    function inferUnitsPerPack(variant) {
      var text = variantText(variant);
      var match = text.match(/(\d{1,5})\s*(?:pz|pzi|pezzi|pcs)\b/i);
      if (match) return Math.max(parseInt(match[1], 10) || 1, 1);
      var sku = variant && variant.sku ? String(variant.sku) : '';
      var skuMatch = sku.match(/[-_\s](\d{1,5})$/);
      if (skuMatch) return Math.max(parseInt(skuMatch[1], 10) || 1, 1);
      return Math.max(parseFloat(unitBox && unitBox.getAttribute('data-units-per-pack')) || 1, 1);
    }

    function setVariantPackUnits(variant) {
      if (!unitBox) return;
      unitBox.setAttribute('data-units-per-pack', String(inferUnitsPerPack(variant)));
    }

    function updateUnitEstimate() {
      if (!unitBox || !unitOut || !totalOut) return;
      // FIX 2026-07-31 (owner): il box "Prezzo per unita / Totale stimato" deve
      // sempre riflettere il prezzo pieno IVA escl. della variante selezionata
      // (data-base-excl), MAI il prezzo scontato del tier sconto-quantita
      // arrivato via gef:bulk:change — quella scala si applica altrove
      // (selettore prezzo volume), non e' il significato di questi due campi.
      var units = parseFloat(unitBox.getAttribute('data-units-per-pack')) || 1;
      var quantity = clampQty();
      var unitExcl = parseFloat(unitBox.getAttribute('data-base-excl')) || 0;
      unitOut.textContent = formatMoney(unitExcl / Math.max(units, 1));
      totalOut.textContent = formatMoney(unitExcl * quantity);
    }

    root.querySelectorAll('[data-qty-dec]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(qtyInput.step, 10) || 1;
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    root.querySelectorAll('[data-qty-inc]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(qtyInput.step, 10) || 1;
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', updateUnitEstimate);
    }
    if (bulkRoot) {
      bulkRoot.addEventListener('gef:bulk:change', function (event) {
        currentBulkDetail = event.detail || null;
        updateUnitEstimate(currentBulkDetail);
      });
    }

    root.querySelectorAll('.gef-cd-pdp__chip input[type=radio]').forEach(function (input) {
      input.addEventListener('change', function () {
        var label = input.closest('.gef-cd-pdp__chip');
        var group = input.closest('fieldset');
        if (group) {
          group.querySelectorAll('.gef-cd-pdp__chip').forEach(function (item) {
            item.classList.remove('is-selected');
          });
        }
        if (label && input.checked) label.classList.add('is-selected');
        syncSelectedVariant();
      });
    });

    function selectedOptions() {
      if (!form) return [];
      var fields = form.querySelectorAll('[name^="options["]');
      var values = [];
      fields.forEach(function (field) {
        if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;
        values.push(field.value);
      });
      return values;
    }

    function syncCtas(available) {
      if (addButton) {
        var proGate = form ? form.querySelector('[data-pro-gate]') : null;
        // Il tema NON valuta piu' da se' il gate professionisti: la vecchia regola
        // (checkbox + campo P.IVA con almeno 3 caratteri) e' incompatibile con il gate
        // a tre vie del 04/08/2026 — sulla via "Albo" il campo P.IVA e' vuoto per
        // costruzione e il bottone restava bloccato per sempre. Unica fonte di verita':
        // il flag che lo snippet del gate scrive su data-pro-gate-complete.
        // Solo un 'false' ESPLICITO (scritto dallo snippet del gate dopo la sua
        // inizializzazione) blocca: all'avvio il dataset non esiste ancora e il tema
        // non deve disabilitare, altrimenti il gate legge quel disabled come blocco
        // ESTERNO (tipo esaurito) e non lo rimuove piu' nemmeno a dati completi.
        var gateComplete = !proGate || addButton.dataset.proGateComplete !== 'false';
        var enabled = !!available && gateComplete;
        addButton.dataset.variantAvailable = available ? 'true' : 'false';
        addButton.disabled = !enabled;
        addButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      }
      if (addLabel) addLabel.textContent = available ? 'Aggiungi al carrello' : 'Richiedi disponibilità';
    }

    function syncDelivery(match) {
      if (!deliveryBox || !deliveryTitle || !deliveryNote || !match) return;
      var available = !!match.available;
      var titleKey = 'data-confirm-title';
      var noteKey = 'data-confirm-note';
      if (requiresStockConfirmation(match)) {
        titleKey = 'data-confirm-title';
        noteKey = 'data-confirm-note';
      } else if (!available) {
        titleKey = 'data-unavailable-title';
        noteKey = 'data-unavailable-note';
      } else if (hasVerifiedOwnedStock(match)) {
        titleKey = 'data-stock-title';
        noteKey = 'data-stock-note';
      } else {
        titleKey = 'data-available-title';
        noteKey = 'data-available-note';
      }
      deliveryTitle.textContent = deliveryBox.getAttribute(titleKey) || '';
      deliveryNote.textContent = deliveryBox.getAttribute(noteKey) || '';
    }

    function updatePriceSub(grossPrice) {
      if (!priceSub || !grossPrice) return;
      var secondaryPrice = priceMode === 'incl' ? grossPrice / vatMultiplier : grossPrice;
      var inclNode = priceSub.querySelector('[data-bulk-incl]');
      if (inclNode) {
        inclNode.textContent = decimalFormatter(secondaryPrice);
        return;
      }
      priceSub.textContent = priceMode === 'incl'
        ? formatMoney(secondaryPrice) + ' IVA esclusa prima delle condizioni quantità.'
        : formatMoney(secondaryPrice) + ' IVA inclusa prima delle condizioni quantità.';
    }

    function updateCompare(compareGross, grossPrice) {
      if (priceCompare) {
        if (compareGross && compareGross > grossPrice) {
          priceCompare.hidden = false;
          priceCompare.textContent = formatMoney(priceMode === 'incl' ? compareGross : compareGross / vatMultiplier);
        } else {
          priceCompare.hidden = true;
        }
      }
      if (pricePct && (!currentBulkDetail || !currentBulkDetail.discount)) {
        if (compareGross && compareGross > grossPrice) {
          var savedPct = Math.round(((compareGross - grossPrice) * 100) / compareGross);
          pricePct.hidden = false;
          pricePct.textContent = '-' + savedPct + '%';
        } else {
          pricePct.hidden = true;
        }
      }
    }

    function updateSku(match) {
      var nextSku = (match && match.sku) ? String(match.sku) : '';
      var productCode = nextSku;
      if (skuText) {
        skuText.hidden = !nextSku;
        if (nextSku) skuText.textContent = 'Codice GEF: ' + nextSku;
      }
      if (copyButton) {
        copyButton.hidden = !nextSku;
        if (nextSku) {
          copyButton.setAttribute('data-pdp-copy', nextSku);
          copyButton.setAttribute('aria-label', 'Copia il codice GEF ' + nextSku);
        }
      }
      root.querySelectorAll('a[href*="/pages/richiedi-preventivo"]').forEach(function (link) {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (!url.searchParams.has('product')) return;
        if (productCode) url.searchParams.set('product_code', productCode);
        else url.searchParams.delete('product_code');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
      root.querySelectorAll('[data-tab-panel="specs"] tr').forEach(function (row) {
        var heading = row.querySelector('th');
        var value = row.querySelector('td');
        if (!heading || !value) return;
        var label = heading.textContent.trim();
        if (label === 'Codice GEF') {
          value.textContent = productCode;
          row.hidden = !productCode;
        }
        if (label === 'SKU variante') {
          value.textContent = nextSku;
          row.hidden = !nextSku;
        }
      });
      root.querySelectorAll('a.gef-cd-pdp__ask-link[href*="wa.me/"]').forEach(function (link) {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        var message = url.searchParams.get('text') || '';
        var codeSuffix = message.match(/^(.*\bCodice GEF\s*)(\S*)$/);
        var prefix = link.getAttribute('data-pdp-whatsapp-prefix');
        if (prefix === null) {
          if (!codeSuffix) return;
          prefix = codeSuffix[1];
          link.setAttribute('data-pdp-whatsapp-prefix', prefix);
        } else if ((codeSuffix && codeSuffix[1] !== prefix) ||
          (!codeSuffix && message !== prefix.replace(/\s*(?:sul\s+)?Codice GEF\s*$/, '').trim())) {
          return;
        }
        var nextMessage = productCode ? prefix + productCode :
          prefix.replace(/\s*(?:sul\s+)?Codice GEF\s*$/, '').trim();
        url.searchParams.set('text', nextMessage);
        link.setAttribute('href', url.toString());
      });
    }

    function syncFeaturedMedia(match) {
      if (!match || !root.gefPdpGallery || typeof root.gefPdpGallery.activate !== 'function') return;
      var featured = match.featured_media || match.featured_image;
      var mediaId = featured && typeof featured === 'object' ? (featured.id || featured.media_id) : featured;
      if (!mediaId && match.featured_media_id) mediaId = match.featured_media_id;
      if (!mediaId) return;
      var target = Array.prototype.find.call(root.querySelectorAll('[data-media-id]'), function (slide) {
        return String(slide.getAttribute('data-media-id')) === String(mediaId);
      });
      if (!target) return;
      root.gefPdpGallery.activate(parseInt(target.getAttribute('data-pdp-slide'), 10) || 0);
    }

    function syncSelectedVariant() {
      if (!variantInput || !variants.length) return;
      var chosen = selectedOptions();
      if (!chosen.length) return;
      var match = variants.find(function (variant) {
        return variant.options && variant.options.length === chosen.length &&
          variant.options.every(function (option, index) { return option === chosen[index]; });
      });
      if (!match) return;
      if (requiresStockConfirmation(match)) {
        navigateToVariant(match.id);
        return;
      }
      variantInput.value = match.id;
      var grossPrice = match.price ? (match.price / 100) : 0;
      var exclPrice = grossPrice ? (grossPrice / vatMultiplier) : 0;
      var compareGross = match.compare_at_price ? (match.compare_at_price / 100) : 0;
      if (priceMain && grossPrice) priceMain.textContent = formatMoney(priceMode === 'incl' ? grossPrice : exclPrice);
      if (match.price) updatePriceSub(grossPrice);
      updateCompare(compareGross, grossPrice);
      updateSku(match);
      syncFeaturedMedia(match);
      if (unitBox && match.price) {
        unitBox.setAttribute('data-base-excl', String(exclPrice));
        setVariantPackUnits(match);
        currentBulkDetail = null;
        updateUnitEstimate();
      }
      syncCtas(match.available);
      if (variantStatus) {
        var status = 'Disponibilità da confermare';
        if (match.available) {
          if (isProtectedStockProduct) status = protectedStockLabel;
          else if (hasVerifiedOwnedStock(match)) status = ownedStockLabel;
          else status = availableStockLabel;
        } else {
          status = 'Disponibilità su richiesta';
        }
        variantStatus.textContent = status;
        variantStatus.classList.toggle('is-unavailable', !match.available);
      }
      if (stockIndicator && stockLabel) {
        var stockClass = 'supplier';
        var stockText = stockIndicator.getAttribute('data-supplier-label') || 'Disponibile su conferma logistica';
        if (match.available && isProtectedStockProduct) {
          stockClass = 'supplier';
          stockText = protectedStockLabel;
        } else if (match.available && hasVerifiedOwnedStock(match)) {
          stockClass = 'immediate';
          stockText = stockIndicator.getAttribute('data-immediate-label') || ownedStockLabel;
        } else if (match.available) {
          stockClass = 'supplier';
          stockText = stockIndicator.getAttribute('data-supplier-label') || availableStockLabel;
        } else if (!match.available) {
          stockClass = 'unavailable';
          stockText = stockIndicator.getAttribute('data-unavailable-label') || 'Su richiesta';
        }
        stockIndicator.classList.remove(
          'gef-cd-pdp__stock-indicator--immediate',
          'gef-cd-pdp__stock-indicator--supplier',
          'gef-cd-pdp__stock-indicator--unavailable'
        );
        stockIndicator.classList.add('gef-cd-pdp__stock-indicator--' + stockClass);
        stockIndicator.classList.toggle('is-available', !!match.available);
        stockLabel.textContent = stockText;
      }
      syncDelivery(match);
      window.dispatchEvent(new CustomEvent('gef:pdp:variant-change', {
        detail: {
          id: match.id,
          available: !!match.available,
          price: match.price,
          compare_at_price: match.compare_at_price,
          title: match.title,
          options: match.options,
          sku: match.sku,
          inventory_quantity: match.inventory_quantity,
          featured_image: match.featured_image,
          featured_media: match.featured_media
        }
      }));
    }

    if (form) {
      form.addEventListener('change', function (event) {
        if (event.target && event.target.name && event.target.name.indexOf('options[') === 0) {
          syncSelectedVariant();
        }
      });
      syncSelectedVariant();
    }
    setVariantPackUnits(findVariantById(variantInput && variantInput.value));
    updateUnitEstimate();
  }

  function init(root) {
    if (!root || root.dataset.gefPdpReady === 'true') return;
    root.dataset.gefPdpReady = 'true';
    initGallery(root);
    initCopy(root);
    initWishlist(root);
    initPurchase(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pdp-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();
